import * as React from "react";

export const ChevronIcon: React.FC<{
  className?: string;
  size?: number;
  color?: string;
}> = ({ className, size = 16, color = "currentColor" }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={size}
    viewBox="0 0 16 16"
    fill="none"
    className={className}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M5.31295 13.0196C5.11769 12.8243 5.11769 12.5077 5.31295 12.3125L9.62606 7.99935L5.31295 3.68624C5.11769 3.49097 5.11769 3.17439 5.31295 2.97913C5.50821 2.78387 5.8248 2.78387 6.02006 2.97913L10.6867 7.6458C10.882 7.84106 10.882 8.15764 10.6867 8.3529L6.02006 13.0196C5.8248 13.2148 5.50821 13.2148 5.31295 13.0196Z"
      fill={color}
    />
  </svg>
);
